export default "__VITE_PUBLIC_ASSET__1608351a__"